<template>
    <div class="project-items" v-if="projectItems != null">
        <!-- v-infinite-scroll="loadMore" :infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-throttle-delay="1000" -->
        <div class="masonry-items" v-masonry column-width="304.99" stagger="0s" transition-duration="0s" item-selector=".project-item" id="masonryItems" :class="{animate : cardAnimate}" v-if="!iSmobile">
            <div v-masonry-tile class="project-item" v-for="(item, index) in projectItems" :data-style="item.acf.project_card_style" :key="item.slug + index">
                <div class="inner" >
                    <!-- :to="{ name : 'sale-card' , params:{id : item.project_name.slug}}" -->
                    <router-link class="link-to-page" :to="{ name : 'project-card' , params:{id : item.slug, 'pageID': page}}" @click.native="startLoader">
                        <div class="item-img">
                            <img :src="item.acf.project_img" alt="">
                        </div>
                    </router-link>
                    <div class="item-desc">
                        <div class="item-type">
                            <h5  v-if="item.acf.project_type != null">{{item.acf.project_type.name}}</h5>
                        </div>
                        <div class="item-title">
                            <h3>{{item.acf.project_name}}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-project-items" v-else>
            <div class="project-item-mobile" v-for="(item, index) in projectItems" :key="item.slug">
                <div class="inner" >
                    <!-- :to="{ name : 'sale-card' , params:{id : item.project_name.slug}}" -->
                    <router-link class="link-to-page" :to="{ name : 'project-card' , params:{id : item.slug, 'pageID': page}}" @click.native="startLoader">
                        <div class="item-img">
                            <img :src="item.acf.project_img" alt="">
                        </div>
                    </router-link>
                    <div class="item-desc">
                        <div class="item-type">
                            <h5  v-if="item.acf.init_custom_type == 'false'">{{item.acf.project_type.name}}</h5>
                            <h5 v-else>{{item.acf.custom_project_type}}</h5>
                        </div>
                        <div class="item-title">
                            <h3>{{item.acf.project_name}}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="project-item" v-for="(item, index) in projectItems" :class="{animate : cardAnimate}">
            
        </div> -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'project-built',
        props: ['projectItems', 'page'],
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                busy: false,
                iSmobile: false,
            }
        },
        computed: mapGetters({
            // projectItems: 'loadBuiltItems',
            // projectItemsDefault: 'loadBuiltItemsDefault',
            cardAnimate: 'loadCardAnimateStatus',
        }),
        methods: {
            loadMore() {
                if (!this.busy) {
                    this.busy = true;
                    setTimeout(() => {
                        // console.log('BOTTOM')
                        this.busy = false;
                    }, 1000);
                }
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.isMobileCheck();
            this.checkResize();
            this.$redrawVueMasonry('#masonryItems');
            // this.$store.watch(
            //     (state) => state.builtItemsTotalPageCount,
            //     (newValue) => {
            //         console.log('resize');
            //         this.$redrawVueMasonry('#masonryItems');
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/projects/projects-item.scss';
    @import '@/styles/components/projects/respond/projects-item-respond.scss';
    // @import '@/styles/respond/projects/projects-built-respond.scss';
</style>